import { RootState } from 'store/reducer';

export const selectMobileAlertOpen = (state: RootState) =>
  state.mobileAlert.state === 'open';

export const selectMobileAlertHadNoInteraction = (state: RootState) =>
  state.mobileAlert.state === 'initial';
